import {getService,postBodyService} from "./base.service";
import config from "../config/application";

//url
const list = 'channel/list';
const add = 'channel/add';
const update = 'channel/update';
const deleteUrl = 'channel/delete';

class ChannelService {
    getChannels(entity) {
        const url = `${config.data.income.channel.url}${list}/${entity}`;
        return getService(url);
    }
    saveChannel(json){
        const url = `${config.data.income.channel.url}${add}`;
        return postBodyService(url,json);
    }
    updateChannel(json){
        const url = `${config.data.income.channel.url}${update}`;
        return postBodyService(url,json);
    }
    deleteChannel(json){
        const url = `${config.data.income.channel.url}${deleteUrl}`;
        return postBodyService(url,json);
    }
    
}
export default new ChannelService(); 